<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>日期选择器组件技能库</h2>
      <p>展示Element UI日期选择器组件的个性化用法</p>
    </div>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="时分秒范围选择" 
          description="时间范围选择器，支持时分秒精确选择"
          :codeContent="hmsRangeCode">
          <HmsRange />
        </CodeCard>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="年月日范围选择" 
          description="日期范围选择器，选择开始和结束日期"
          :codeContent="ymdRangeCode">
          <YmdRange />
        </CodeCard>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="年月日时分秒" 
          description="完整的日期时间选择器"
          :codeContent="ymdhmsCode">
          <Ymdhms />
        </CodeCard>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="6">
        <CodeCard 
          title="年月日时分秒范围" 
          description="带自定义样式的日期时间范围选择器"
          :codeContent="ymdhmsRangeCode">
          <YmdhmsRange />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import HmsRange from './components/HmsRange.vue'
import YmdRange from './components/YmdRange.vue'
import Ymdhms from './components/Ymdhms.vue'
import YmdhmsRange from './components/YmdhmsRange.vue'

export default {
  name: 'PcDate',
  components: {
    CodeCard,
    HmsRange,
    YmdRange,
    Ymdhms,
    YmdhmsRange
  },
  data() {
    return {
      hmsRangeCode: `<template>
  <el-time-picker
    v-model="localValue"
    is-range
    arrow-control
    format="HH:mm:ss"
    value-format="HH:mm:ss"
    range-separator="至"
  />
</template>`,
      ymdRangeCode: `<template>
  <el-date-picker
    v-model="localValue"
    type="daterange"
    format="yyyy-MM-dd"
    value-format="yyyy-MM-dd"
    range-separator="至"
  />
</template>`,
      ymdhmsCode: `<template>
  <el-date-picker
    v-model="localValue"
    type="datetime"
    format="yyyy-MM-dd HH:mm:ss"
    value-format="yyyy-MM-dd HH:mm:ss"
    default-time="00:00:00"
  />
</template>`,
      ymdhmsRangeCode: `<template>
  <el-date-picker
    v-model="localValue"
    type="datetimerange"
    format="yyyy-MM-dd HH:mm:ss"
    value-format="yyyy-MM-dd HH:mm:ss"
    :default-time="['00:00:00', '23:59:59']"
    range-separator="至"
  />
</template>`
    }
  }
}
</script>

<style scoped>
/* 全局样式已由 global.scss 提供 */
</style>
